export default "__VITE_ASSET__CnQmf6L___"